module.exports = __webpack_public_path__ + "media/images/beauty/cover-desktop@3x-c3d6821a8ad73329443fac29782ec10e.jpg";